import { render } from "./StationDetails.vue?vue&type=template&id=4b0a9620&ts=true"
import script from "./StationDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./StationDetails.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Orchard/WeatherStation/StationDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b0a9620"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b0a9620', __exports__)) {
    console.log('reload')
    api.reload('4b0a9620', __exports__)
  }
  
  module.hot.accept("./StationDetails.vue?vue&type=template&id=4b0a9620&ts=true", () => {
    console.log('re-render')
    api.rerender('4b0a9620', render)
  })

}


export default __exports__